import {
  ACCOUNT_INFO_LOADED,
  FORM_SUBMISSION_FAILED,
  FORM_SUBMITTED,
  PAGES,
  START_CLICKED,
} from "./constants";
import { Action, FormValues, State } from "./types";

const emptyFormValues: FormValues = {
  letterType: "",
  firstName: "",
  lastName: "",
  dateOfBirth: {
    day: "",
    month: "",
    year: "",
  },
  mobileNumber: "",
};

const initialRequestLetterState: State = {
  page: PAGES.LANDING,
  formValues: emptyFormValues,
};

function requestLetterReducer(state: State, action: Action): State {
  switch (state.page) {
    case PAGES.LANDING: {
      switch (action.type) {
        case ACCOUNT_INFO_LOADED: {
          return {
            ...state,
            accountInfo: action.accountInfo,
          };
        }

        case START_CLICKED: {
          return {
            ...state,
            page: PAGES.FORM,
          };
        }

        default: {
          return state;
        }
      }
    }

    case PAGES.FORM: {
      switch (action.type) {
        case FORM_SUBMITTED: {
          return {
            ...state,
            page: PAGES.SUCCESS,
            formValues: action.formValues,
          };
        }

        case FORM_SUBMISSION_FAILED: {
          return {
            ...state,
            page: PAGES.ERROR,
          };
        }

        default: {
          return state;
        }
      }
    }

    default: {
      return state;
    }
  }
}

export { initialRequestLetterState, requestLetterReducer };
